import { MutableRefObject, useCallback, useEffect } from 'react';

export function useClickOutside(
  ref: any,
  callbackfunction: any,
  excludedElements?: Array<MutableRefObject<any>>
) {
  const handleClickOutside = useCallback(
    (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        let isExcluded = false;
        if (excludedElements) {
          for (const excludedElement of excludedElements) {
            if (excludedElement.current?.contains(event.target)) {
              isExcluded = true;
              break;
            }
          }
        }
        if (!isExcluded) {
          callbackfunction(event);
        }
      }
    },
    [callbackfunction, excludedElements, ref]
  );

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callbackfunction(event);
      } else if (event.key === 'Tab') {
        setTimeout(() => {
          const activeElement = document.activeElement;
          if (
            activeElement &&
            ref.current &&
            !ref.current.contains(activeElement)
          ) {
            let isExcluded = false;
            if (excludedElements) {
              for (const excludedElement of excludedElements) {
                if (excludedElement.current?.contains(activeElement)) {
                  isExcluded = true;
                  break;
                }
              }
            }
            if (!isExcluded) {
              callbackfunction(event);
            }
          }
        }, 0);
      }
    },
    [callbackfunction, excludedElements, ref]
  );

  useEffect(() => {
    const handleDocumentClick = (event: any) => handleClickOutside(event);
    document.addEventListener('mousedown', handleDocumentClick);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    ref,
    callbackfunction,
    excludedElements,
    handleClickOutside,
    handleKeyDown
  ]);
}
